import AWS from "aws-sdk";

// 파일명 특수문자 체크 정규식 (-, _, .은 제외)
const REGEX_FILENAME = /[\{\}\[\]\/?,;:|\)*~`!^\+<>@\#$%&\\\=\(\'\"]/g;
// 가능한 파일 확장자
const available_file_extension = ['jpg', 'pdf', 'png', 'heic', 'heif', 'jpeg']; // 고효율사진 파일 ACCEPT 추가 
// 파일 최대 크기
const DEFAULT_FILE_SIZE_LIMIT = 10 * 1024 * 1024; // 10MB
// 파일 타입 체크 정규식
// export const REGEX_FILETYPE = /(.*?)\.(docx|pdf|xlsx|png|pptx|zip)$/;
const REGEX_FILETYPE = new RegExp(`(.*?)\\.(${available_file_extension.join('|')})$`);

// 첨부 파일 체크
export const validateFile = (file) => {
  // 파일명 체크
  // if(REGEX_FILENAME.test(file.name)) {
  //   return '파일명에 특수문자(-, _, .제외)가 포함된 파일은 추가하실 수 없습니다.';
  // }

  // 파일 확장자 체크
  const fileType = file.name.substring(file.name.lastIndexOf('.')).toLowerCase();
  if(!REGEX_FILETYPE.test(fileType)) {
    return `${available_file_extension.join(',')} 파일만 첨부가능합니다.`;
  }

  // 파일 크기 체크
  if(file.size > DEFAULT_FILE_SIZE_LIMIT) {
    return `${DEFAULT_FILE_SIZE_LIMIT / (1024 * 1024)}MB까지 첨부 가능합니다.`;
  }

  return null;
}

AWS.config.update({
  region: process.env.AWS_REGION,
  credentials: new AWS.CognitoIdentityCredentials({
    IdentityPoolId: process.env.AWS_IDENTITY_POOL_ID,
  }),
});

// s3 버킷 설정
const s3 = new AWS.S3({
  apiVersion: "2012-10-17",
  params: {
    Bucket: process.env.AWS_BUCKET_NAME,
  },
});

export function uploadFileToS3(key, file, sizeLimit) {
  return s3.upload(
    { Key: key, Body: file, ACL: 'public-read' },
    { partSize: sizeLimit || DEFAULT_FILE_SIZE_LIMIT }
  ).promise();
};

export function deleteFileFromS3(key) {
  return s3.deleteObject({ Key: key }).promise();
}

export function deleteFilesFromS3(keys) {
  const objects = keys.map(key => ({ Key: key }));
  return s3.deleteObjects({ Delete: { Objects: objects } }).promise();
}